import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { http } from "../../lib/api";

const SEM = { Verde: "text-emerald-700", Amarillo: "text-amber-600", Rojo: "text-rose-600", Watchlist: "text-fuchsia-700" };

// KPIs EWS de la Cartera SOFIPO para Inicio y Riesgo de portafolio
export const EwsKpis = ({ testid = "ews-kpis" }) => {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/ews/kpis", { params: { dataset: "sofipo" } }).then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  return (
    <Link to="/alertas" data-testid={testid} className="block rounded-2xl border border-[#E2DDD5] bg-white p-4 transition-transform duration-200 hover:-translate-y-0.5">
      <div className="flex items-center justify-between"><p className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-widest text-[#8C867A]"><ShieldAlert size={14} /> Alertas tempranas · SOFIPO</p>
        <span className="text-xs text-[#8C867A]">{d.abiertas} abiertas · {d.altas} altas</span></div>
      <div className="mt-2 flex flex-wrap gap-4">{Object.entries(d.semaforo).map(([k, v]) => <p key={k} className={`font-serif-display text-2xl font-bold ${SEM[k]}`} data-testid={`${testid}-${k.toLowerCase()}`}>{v} <span className="text-xs font-sans font-semibold">{k}</span></p>)}</div>
      {d.portafolio.map((p) => <p key={p} className="mt-1 text-xs font-semibold text-rose-700" data-testid={`${testid}-portafolio`}>Portafolio: {p}</p>)}
    </Link>
  );
};
